import { Fragment, memo } from "react";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";
import config from "../../../config/index";
import styles from "./WarningTitle.module.scss";

const WarningTitle = memo(({ title, contents, className, id }) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const iconTypeSvg = "warning-black.svg";
  const iconTypePath = `${imagePrefix}/assets/images/${iconTypeSvg}`;

  const ListItem = ({ index, desc }) => {
    return (
      <>
        <li
          id={`${id}-item-${index}`}
          className={styles["desc"]}
          dangerouslySetInnerHTML={createMarkup(desc)}
        ></li>
      </>
    );
  };

  const listItems = contents.map((item, index) =>
    item ? (
      <Fragment key={index}>
        <ListItem
          index={index}
          desc={item.description ? item.description : item}
        />
      </Fragment>
    ) : (
      ""
    )
  );

  return (
    <div className={`${styles["warningTitle"]} ${className}`} id={id}>
      {title && (
        <div className={styles["warningTitle__heading"]}>
          <img className={styles["icon"]} src={iconTypePath} />
          <span className={styles["title"]}>{title}</span>
        </div>
      )}
      <ul className={`${styles["warningTitle__content"]}`}>{listItems}</ul>
    </div>
  );
});

WarningTitle.defaultProps = {
  title: null,
  contents: [],
};

WarningTitle.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.array,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default WarningTitle;
